import {Component, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import {AppMemoryService} from '../../core/app-memory.service';
import {DatePipe} from '@angular/common';
import {GetService} from '../../core/get.service';
import {Farm} from '../../core/classes/farm';
import {NotificationsService} from 'angular2-notifications';
import {Router, ActivatedRoute} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-yards',
    templateUrl: './yards.component.html',
    styleUrls: ['./yards.component.less'],
})
export class YardsComponent implements OnInit, OnDestroy {
    @HostListener('document:scroll', ['$event'])
    onWindowScroll() {
        if ($(window).scrollTop() >=
            $(document).height() - $(window).height() - 100) {
            this.addNewData(this.yards);
        }
    }

    @ViewChild('imageLoader') public imageLoader: any;

    @ViewChild('newFarmCountry') public newFarmCountry: any;

    @ViewChild('createFarmForm') public createFarmForm: any;

    @ViewChild('newMicrochipNumber') public newMicrochipNumber: any;

    public _searchStream = new Subject<any>();

    public yards: Farms;

    public pagination = {
        inProgress: false as boolean,
        nextPage: '' as string,
    };

    public serverError = null;
    public isRequestInProgress = false;

    public newFarm = new Farm();

    public countries: any[];
    public countriesSub: Subscription;
    public regions: any[];
    public regionsSub: Subscription;
    public showRegionsSelect: boolean = environment.showRegionsSelect;

    public loadSuggestion: boolean;

    public isUserLoaded = false;

    public searchString: string;

    public translation = {};

    constructor(private notificationsService: NotificationsService,
                public appMemory: AppMemoryService,
                public getService: GetService,
                public datePipe: DatePipe,
                public router: Router,
                public route: ActivatedRoute,
                private translateService: TranslateService) {
        this.appMemory.userSubject.subscribe(e => {
            if (this.appMemory.user && e && !this.isUserLoaded) {
                this.getFarms();
            }
        });
        this.getTranslation();
    }

    ngOnInit(): void {
        this._searchStream.debounceTime(200).subscribe(res => {
            if (res && res.length > 0) {
                this.getFarms(res);
            }
        });

        this.countriesSub = this.appMemory.countries.subscribe(countries => {
            if (countries) {
                countries.forEach(e => {
                    e.text = e.name;
                });

                this.countries = countries;
            }
        });
        this.regionsSub = this.appMemory.regions.subscribe(regions => {
            if (regions) {
                regions.forEach(e => {
                    e.text = e.name;
                });

                this.regions = regions;
            }
        });
    }

    ngOnDestroy() {
        if (this._searchStream) {
            this._searchStream.unsubscribe();
        }

        if (this.countriesSub) {
            this.countriesSub.unsubscribe();
        }
        if (this.regionsSub) {
            this.regionsSub.unsubscribe();
        }
    }

    objectToArray(obj: Object) {
        return Object.keys(obj).map(key => obj[key]); // transorm Array-like Object to Array
    }

    createFarm(form: any) {
        if (form.form.invalid || !this.newFarm.country_id) {
            return;
        }

        const formData = {
            name: this.newFarm.name,
            address_first: this.newFarm.address_first,
            address_second: this.newFarm.address_second,
            city: this.newFarm.city,
            region: this.newFarm.region,
            post_code: this.newFarm.post_code,
            country_id: this.newFarm.country_id
        };

        this.isRequestInProgress = true;
        this.getService.createFarm(formData).then(
            (res: any) => {
                this.isRequestInProgress = false;

                this.clearUserInput(this.createFarmForm);
                this.hideModal();
                this.getFarms();
                this.notificationsService.success(
                    `${this.translation['addYard']}`,
                    `${this.translation['yard']} ${this.translation['addedSuccess']}`
                );
                // this.notificationsService.success(
                //     'Add Yard',
                //     'Yard added successfully'
                // );
            },
            (err: any) => {
                this.isRequestInProgress = false;
                this.notificationsService.error(
                    `${this.translation['addYard']}`,
                    `${this.translation['errorOccurred']}`
                );
                this.serverError = this.objectToArray(JSON.parse(err._body));
            }
        );
    }

    clearUserInput(form: any) {
        this.serverError = null;
        form.resetForm();
        this.newFarm = new Farm();
        $('#farm-name-box').removeClass('input--filled');
        $('#farm-descr-box').removeClass('input--filled');
        $('#microchip-number-box').removeClass('input--filled');
    }

    getAge(dateString) {
        const today = new Date();
        const birthDate = new Date(dateString);
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }

    hideModal() {
        $('.modal.open').removeClass('open');
        $('body').removeClass('modal-open');
    }

    addNewData(items: any) {
        if (this.pagination.nextPage === null ||
            this.pagination.inProgress ||
            this.pagination.nextPage === '') {
            return;
        }

        this.pagination.inProgress = true;
        this.getService.rawRequest(this.pagination.nextPage).then(
            (res: any) => {
                res.data.forEach((item: any) => {
                    items.push(item);
                });

                if (res.next_page_url) {
                    this.pagination.nextPage = res.next_page_url + '&treatment=true';
                } else {
                    this.pagination.nextPage = res.next_page_url;
                }

                this.pagination.inProgress = false;
            },
            (err: any) => {
                this.pagination.inProgress = false;
            }
        );
    }

    getFarms(name?: string) {

        this.getService.getFarms(name).then(
            res => {
                this.yards = res.data;
                if (res.next_page_url) {
                    this.pagination.nextPage = res.next_page_url;
                }
            },
            err => {

            }
        );
    }

    setCountryId(e) {
        this.newFarm.country_id = e.id;
    }
    setRegion(e) {
        this.newFarm.region = e.id;
    }

    getTranslation() {
        this.translateService.get('OTHER.addedSuccess').subscribe((word: string) => {
          this.translation['addedSuccess'] = word;
        });
        this.translateService.get('YARDS.addYard').subscribe((word: string) => {
            this.translation['addYard'] = word;
        });
        this.translateService.get('CORE.yard').subscribe((word: string) => {
            this.translation['yard'] = word;
        });
        this.translateService.get('OTHER.errorOccurred').subscribe((word: string) => {
            this.translation['errorOccurred'] = word;
        });
        this.translateService.get('HORSES.addNote').subscribe((word: string) => {
            this.translation['addNote'] = word;
        });
        this.translateService.get('HORSES.note').subscribe((word: string) => {
            this.translation['note'] = word;
        });
      }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/yards/yards.component.ts